import React from 'react'
import styles from './EditNote.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import useLocalization from 'hooks/useLocalization'
import { classNames as cn } from 'helpers'

const EditNote = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'customer_card',
    dict: {
      edit_note: 'Edit Note',
    },
  })

  return (
    <FormField>
      <FormLabel>{translate.edit_note}</FormLabel>
      <textarea
        placeholder={translate.edit_note}
        value={modalValue?.note}
        onChange={(e) => changeValues(e.target.value, 'note')}
        className={cn({
          [styles.textarea]: true,
          [styles.error]: check('note') || !modalValue?.note.trim(),
        })}
      />
    </FormField>
  )
}

export default observer(EditNote)
